<template>
  <k-modal v-if="isLoggedIn" :show="show" @close="close">
    <template #header>
      <h2>Ask for help</h2>
      <p v-if="currentProblemGroup">{{currentProblemGroup.msg}}</p>
      <p v-if="currentProblemGroup && currentProblemGroup.key === 'help_content'" class="help-description"></p>
    </template>
    <template #body>
      <div class="issue-body">
        <form v-if="currentProblemGroup" @submit.prevent="submitForm" class="help-ticket-form" enctype="multipart/form-data">
          <fieldset v-if="defaultModuleName" class="form-entry">
            <label for="module-input">Module:
              <input id="module-input" v-model="moduleName" disabled class="form-input k-issue-text">
            </label>
          </fieldset>

          <fieldset v-if="defaultContentName" class="form-entry">
            <label for="content-input">{{ contentText }}:</label>
            <input id="content-input" v-model="contentName" disabled class="form-input k-issue-text">
          </fieldset>

          <fieldset class="subject-wrapper form-entry">
            <label for="subject-input">Subject:</label>
            <input id="subject-input" placeholder="Enter subject here..." class="form-input k-issue-text" v-model="subject" maxlength="256">
          </fieldset>

          <fieldset class="textareawrapper form-entry">
            <k-text-editor v-model="message" label="Message:" placeholder="Enter message here..." :max-length="messageMaxLength"></k-text-editor>
          </fieldset>

          <fieldset v-if="isBugReport" class="bug-report-field">
            <label for="upload-file-input" class="bug-report-label">
              Attachment(s):
            </label>
            <button type="button" class="btn-icon" @click="$emit('enter-screenshot-mode')">Take screenshot <i title="Take a screenshot in KATE" class="fas fa-camera"  aria-hidden="true"></i></button>
            <hr>
            <button type="button" class="btn-icon" @click="openUploadDialog">Upload image(s) <i title="Upload your own screenshot" class="fas fa-upload" aria-hidden="true"></i></button>
            <input id="upload-file-input" type="file" name="files" accept="image/*" ref="filesInput" style="display: none;" @change="filesChange($event.target.files)" multiple>
            <k-file-list :files="files" @remove-file="removeStagedFile"></k-file-list>
            <k-file-list :files="screenshots" @remove-file="removeScreenshot"></k-file-list>
          </fieldset>
        </form>
      </div>
    </template>
    <template #footer>
      <button :disabled="disableSend" @click="submitForm" class="btn btn-primary send-btn">Send <i :class="sendIconClass"></i></button>
    </template>
  </k-modal>
</template>

<style>
.issue-dropdown button.k-search-dropdown-button {
  padding: 10px;
  margin: 0;
  transition: all 0.3s ease;
  border-radius: 4px;
  color: var(--kate-mono-0);
}

.issue-dropdown button.k-search-dropdown-button:hover {
  background-color: var(--kate-button-tertiary-hover);
}

.issue-dropdown .k-search-dropdown-adv-content {
  min-width: 250px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--kate-mono-0);
  border-radius: 0;
  padding: 0;
}

.issue-dropdown .k-search-dropdown-adv,
.issue-dropdown input {
  margin: 7px auto;
  width: 90%;
  display: block;
  padding: 5px;
  border: 1px solid var(--kate-type-primary);
  background-color: var(--kate-type-light);
  outline: 0;
}

.issue-dropdown input::placeholder {
  color: var(--kate-type-alt-dark);
}

.issue-dropdown .k-search-dropdown-label:first-child {
  border-top: 0;
}

.issue-dropdown .k-search-dropdown-label {
  color: var(--kate-type-alt-dark);
  border-top: var(--border-primary);
  border-radius: 0;
  margin: 0;
  padding: 15px 10px;
  width: 100%;
}

.issue-dropdown .k-search-dropdown-label:hover {
  background-color: var(--kate-panel-alt);
}

.help-container .modal-container,
.help-modal .modal-container {
  width: 60vw;
}

.help-container .modal-body {
  overflow: hidden;
}

.btn .fas.fa-angle-right,
.btn .fas.fa-calendar {
  position: relative;
  bottom: -1px;
  padding-left: 3px;
}

.highlight {
  font-weight: bold;
  color: var(--kate-2);
}

@media only screen and (max-width: 767px) {
  .help-container .modal-container {
    width: 90vw;
  }
}
</style>

<style scoped>
.help-ticket-form fieldset {
  margin: 10px 0;
}

.bug-report-field {
  overflow-x: hidden;
}

.form-input {
  width: 100%;
  margin-bottom: 0.5em;
}

.issue-body {
  min-height: 200px;
}

.issue-body p {
  color: var(--kate-type-light);
}

.issue-body label {
  padding-left: 0;
}

.k-issue-text {
  width: 100%;
  background-color: var(--input-background);
  border: 0;
  color: var(--kate-type-light);
  padding: 6px 12px;
}

input:disabled::placeholder {
  color: var(--kate-disabled);
}

.k-issue-text:disabled {
  background-color: var(--kate-disabled);
}

.send-btn {
  width: 200px;
  transition: all 0.3s;
}

.send-btn:hover:disabled,
.send-btn:disabled {
  background-color: var(--kate-button-primary);
}

.send-btn:focus {
  color: var(--kate-type-light);
  outline: 0;
}

.send-btn i {
  transform: rotate(15deg);
  margin-left: 20px;
}

.bug-report-label span {
  cursor: pointer;
  padding: 10px;
  font-size: 0.9em;
  color: var(--kate-type-primary);
}

.bug-report-label span i {
  color: var(--kate-type-light);
  padding-left: 5px;
  font-size: 1.15em;
}

.bug-report-label span:hover i,
.bug-report-label span:hover {
  color: var(--kate-primary);
}

.bug-report-label hr {
  margin: 0 5px;
  border-top: 0;
  border-right: var(--border-primary);
  display: inline;
}

@media only screen and (max-width: 767px) {
  .send-btn {
    width: 100%;
  }
}
</style>

<script>
import useGlobalStore from '@stores/global';
import useAppProgrammeStore from '@stores/app-programme-store';
import KModal from '@base-components/k-modal.vue';
import CoachDataMentorMixin from '@mixins/coach-data-mentor-mixin';
import KFileList from '@base-components/k-file-list.vue';
import KTextEditor from '@base-components/k-text-editor.vue';

const PROBLEM_GROUPS = [
  {
    group: 'course_content',
    msg: 'Get help for assignment or learning units',
    key: 'help_pak_lus',
  },
  {
    group: 'edukate_account',
    msg: 'Report a bug on the platform',
    key: 'report_bug',
  },
  {
    group: 'course_content',
    msg: 'Report a bug with the content',
    key: 'help_content',
  },
  {
    group: 'edukate_account',
    msg: 'Suggest a new feature',
    key: 'feature_request',
  },
  {
    group: 'course_logistics',
    msg: 'Contact Cambridge Spark',
    key: 'other_issue',
  },
];

export default {
  mixins: [CoachDataMentorMixin],
  components: {
    KTextEditor,
    'k-modal': KModal,
    'k-file-list': KFileList,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultModuleName: {
      type: String,
    },
    defaultAssetName: {
      type: String,
    },
    defaultThreadName: {
      type: String,
    },
    helpKey: {
      type: String,
      default: undefined,
    },
    programmeId: {
      type: Number,
      default: undefined,
    },
    moduleId: {
      type: Number,
      default: undefined,
    },
    moduleAssetTypePretty: {
      type: String,
    },
    moduleAssetId: {
      type: Number,
      default: undefined,
    },
    assetId: {
      type: Number,
      default: undefined,
    },
    moduleAssetType: {
      type: String,
      default: undefined,
    },
    threadId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      store: useGlobalStore(),
      programmeStore: useAppProgrammeStore(),
      messageMaxLength: 10240,
      message: '',
      isSending: false,
      subject: '',
      moduleName: this.defaultModuleName,
      contentName: '',
      files: [],
      screenshots: [],
    };
  },

  created() {
    this.contentName = this.defaultAssetName || this.defaultThreadName;
  },

  watch: {
    defaultModuleName() {
      this.moduleName = this.defaultModuleName;
    },
    defaultContentName() {
      this.contentName = this.defaultContentName;
    },
    inScreenshotMode() {
      if (this.inScreenshotMode === false) {
        // Exiting screenshot mode --> add screenshot to files
        const blob = this.store.screenshotBlob;
        // Hack using .slice to create a copy of the blob and ensure the Content-Type is set correctly
        if (blob) {
          const screenshot = blob.slice(0, blob.size, 'image/jpeg');
          this.screenshots.push(screenshot);
          // Remove the screenshot from the store
          this.store.clearScreenshotBlob();
        }
      }
    },
    isSending(newVal) {
      if (newVal) {
        this.$Loading.minimal();
      } else {
        this.$Loading.finish();
      }
    },
  },

  computed: {
    programmes() {
      return this.programmeStore.programmes;
    },
    isDashboard() {
      return this.store.isDashboard;
    },
    contentText() {
      if (this.moduleAssetTypePretty) {
        return this.moduleAssetTypePretty;
      }
      if (this.defaultThreadName) {
        return 'Thread';
      }
      return 'Content';
    },
    defaultContentName() {
      return this.defaultAssetName || this.defaultThreadName;
    },
    isLoggedIn() {
      return this.store.isLoggedIn;
    },
    sendIconClass() {
      return this.isSending ? 'fas fa-spinner fa-spin' : 'fas fa-paper-plane';
    },
    validForm() {
      return Boolean(this.message && this.subject && this.currentProblemGroup !== undefined);
    },
    messageTooLong() {
      return String(this.message || '').length > this.messageMaxLength;
    },
    disableSend() {
      return !this.validForm || this.isSending || this.messageTooLong;
    },
    currentProblemGroup() {
      if (!this.helpKey) {
        return undefined;
      }
      return PROBLEM_GROUPS.find(x => x.key === this.helpKey);
    },
    isBugReport() {
      if (!this.currentProblemGroup) {
        return undefined;
      }
      return this.currentProblemGroup.key === 'report_bug';
    },
    inScreenshotMode() {
      return this.store.inScreenshotMode;
    },
    allFiles() {
      return [...this.screenshots, ...this.files];
    },
  },

  methods: {
    getImageSrc(file) {
      return URL.createObjectURL(file);
    },
    clearFields() {
      this.message = '';
      this.subject = '';
      if (!this.defaultModuleName) {
        this.moduleName = '';
      }
      if (!this.defaultContentName) {
        this.contentName = '';
      }
    },
    clearFiles() {
      this.screenshots = [];
      this.files = [];
    },
    getIssueTags() {
      return this.programmes.map(x => `cohort:${x.key}`);
    },
    openUploadDialog() {
      this.$refs.filesInput.click();
    },
    close() {
      this.clearFields();
      this.clearFiles();
      this.$emit('close');
    },
    filesChange(files) {
      this.$logger.info('Staged files for upload', { files: [...files].map(x => x.name) });
      this.files = Array.from(files);
    },
    submitForm() {
      if (this.disableSend) {
        return;
      }
      this.reportIssue();
    },
    reportIssue() {
      this.isSending = true;
      const jsonPayload = {
        subject: this.subject,
        description: this.$kpurify.sanitise(this.message),
        programme_id: this.programmeId == null ? null : Number(this.programmeId),
        module_id: this.moduleId == null ? null : Number(this.moduleId),
      };
      if (this.moduleName) {
        jsonPayload.module_name = this.moduleName;
      }
      if (this.defaultAssetName) {
        jsonPayload.asset_name = this.contentName;
        jsonPayload.asset_type = this.moduleAssetType;
        if (this.moduleAssetId) {
          jsonPayload.module_asset_id = this.moduleAssetId;
        }
        if (this.assetId) {
          jsonPayload.asset_id = this.assetId;
        }
      }
      if (this.defaultThreadName) {
        jsonPayload.asset_name = this.contentName;
      }
      if (this.threadId) {
        jsonPayload.thread_id = this.threadId;
      }

      // Build form data and post to bug-report endpoint
      const formData = new FormData();
      formData.append('json_payload', JSON.stringify(jsonPayload));
      for (let i = 0; i < this.screenshots.length; i++) {
        formData.append('files', this.screenshots[i], `kate-screenshot-${i + 1}.jpg`);
      }
      for (let i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i], this.files[i].filename);
      }
      this.$http.post(`/api/support/bug-report${this.isDashboard ? '?is_internal=true' : ''}`, formData)
        .then(() => {
          this.$ktoast.info('Bug report sent');
          this.clearFields();
          this.close();
        }).catch(err => {
          // Show custom error if file is too large and if its a 413
          // this.$ktoast.showError(err, err?.response?.data?.err !== 'file_too_large' && err?.response?.status !== 413);
          // Show actual error message for 10 seconds to help debug why users can't submit bug reports
          this.$ktoast.showError(err, false, 10000);
          this.$logger.error('Error submitting bug report', undefined, err);
        }).then(() => {
          this.isSending = false;
        });
    },
    removeStagedFile(payload) {
      this.$logger.info(`Removing staged file ${payload.file.name}`);
      this.files.splice(payload.index, 1);
    },
    removeScreenshot(payload) {
      this.$logger.info(`Removing screenshot ${payload.file.name}`);
      this.screenshots.splice(payload.index, 1);
    },
  },
};
</script>
